import { render, staticRenderFns } from "./CenteredBox.vue?vue&type=template&id=2d5bd886&scoped=true&"
import script from "./CenteredBox.vue?vue&type=script&lang=js&"
export * from "./CenteredBox.vue?vue&type=script&lang=js&"
import style0 from "./CenteredBox.vue?vue&type=style&index=0&id=2d5bd886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5bd886",
  null
  
)

export default component.exports